export default {
	root: ({ props }) => ({
		class: ['datepicker-root', { 'datepicker-fluid': props.fluid }]
	}),
	pcInput: ({ props, parent }) => ({
			root: {
				class: ['datepicker-input', 'font-inter', { filled: parent.instance?.$name == 'FloatLabel' && props.modelValue !== null }]
			}
	}),
	dropdownIcon: { class: 'datepicker-dropdown-icon' },
	dropdown: { class: 'datepicker-dropdown' },
	inputIconContainer: 'datepicker-input-icon-container',
	inputIcon: 'datepicker-input-icon',
	panel: ({ props }) => ({
		class: ['datepicker-panel', { 'datepicker-panel-inline': props.inline, 'datepicker-panel-touch': props.touchUI }]
	}),
	header: { class: 'datepicker-header' },
  	title: { class: 'datepicker-title' },
	selectMonth: { class: 'datepicker-select-month' },
	selectYear: { class: 'datepicker-select-year' },
	table: { class: 'datepicker-table' },
	tableHeaderCell: { class: 'datepicker-table-header-cell' },
	weekHeader: { class: 'datepicker-week-header' },
	weekNumber: { class: 'datepicker-week-number' },
	weekday: { class: 'datepicker-weekday' },
	dayCell: { class: 'datepicker-day-cell' },
	weekLabelContainer: { class: 'datepicker-week-label' },
	dayView: 'datepicker-day-view',
	day: ({ context }) => ({
		class: ['datepicker-day', { 'datepicker-day-today': context.date.today, 'datepicker-day-disabled': context.disabled, 'datepicker-day-selected': context.selected }]
	}),
	monthView: { class: 'datepicker-month-view' },
  	month: ({ context }) => ({ class: ['datepicker-month', { 'datepicker-month-selected': context.selected, 'datepicker-month-disabled': context.disabled }] }),
	yearView: { class: 'datepicker-year-view' },
	year: ({ context }) => ({ class: ['datepicker-year', { 'datepicker-year-selected': context.selected, 'datepicker-year-disabled': context.disabled }] }),
	timePicker: { class: 'datepicker-timepicker' },
	separatorContainer: { class: 'datepicker-separator-container' },
	separator: { class: 'datepicker-separator' },
	hourPicker: { class: 'datepicker-hour-picker' },
	minutePicker: { class: 'datepicker-minute-picker' },
	secondPicker: { class: 'datepicker-second-picker' },
	ampmPicker: { class: 'datepicker-ampm-picker' },
	calendarContainer: 'datepicker-calendar-container',
	calendar: 'datepicker-calendar',
	buttonbar: { class: 'datepicker-buttonbar' },
	transition: {
		enterFromClass: 'datepicker-enter-from',
		enterActiveClass: 'datepicker-enter-active',
		leaveActiveClass: 'datepicker-leave-active',
		leaveToClass: 'datepicker-leave-to'
	}
};